import { ADVISOR_SESSION_FRAGMENT } from '@src/gql/fragments/AdvisorSessionFragment'
import { gql } from '@src/lib/gql'

export const REQUEST_ADVISOR_SESSION = gql`
  mutation RequestAdvisorSession($input: RequestAdvisorSessionInput!) {
    requestAdvisorSession(input: $input) {
      advisorSession {
        ...AdvisorSessionFragment
      }
      precharge {
        id
        advisorSessionChargeId
        advisorSessionId
        amountUsd
        statusKey
        stripeClientSecret
        stripeConnectAccountId
        stripeCustomerSessionClientSecret
        stripePaymentIntentId
      }
    }
  }
  ${ADVISOR_SESSION_FRAGMENT}
`
